// [BD feat] Collection infinite scroll — bd-collection-infinite.js
// Auto-fetches the next paginated page via Section Rendering API when the
// sentinel nears the viewport, appends grid items, and keeps going across
// sparsely filtered pages (single/bundle tag skips) until products appear
// or pagination ends. Re-binds after bd-collection-filter swaps.
(function () {
  'use strict';

  var LOADING = 'bd-collection-grid__infinite--loading';
  var MAX_EMPTY_PAGES = 6;
  var ROOT_MARGIN = '600px 0px';

  function stripScrollTriggers(scope) {
    var nodes = scope.querySelectorAll('.scroll-trigger');
    Array.prototype.forEach.call(nodes, function (el) {
      el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
    });
  }

  function sentinelInView(el) {
    if (!el || el.hidden) return false;
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight + 600;
  }

  function initResults(results) {
    if (!results || results.getAttribute('data-bd-infinite-init') === 'true') return;

    var sectionId =
      results.getAttribute('data-bd-section-id') ||
      (results.closest('[data-section-id]') &&
        results.closest('[data-section-id]').getAttribute('data-section-id'));
    if (!sectionId) return;

    var grid = results.querySelector('[data-bd-product-grid], #product-grid');
    var sentinel = results.querySelector('[data-bd-infinite]');
    if (!grid || !sentinel) {
      results.setAttribute('data-bd-infinite-init', 'true');
      return;
    }

    var busy = false;
    var observer = null;

    function nextUrl() {
      return sentinel.getAttribute('data-bd-next-url') || '';
    }

    function setNextUrl(url) {
      if (url) {
        sentinel.setAttribute('data-bd-next-url', url);
        sentinel.hidden = false;
      } else {
        sentinel.removeAttribute('data-bd-next-url');
        sentinel.hidden = true;
        if (observer) observer.disconnect();
      }
    }

    function fetchPage(url) {
      var fetchUrl;
      try {
        fetchUrl = new URL(url, window.location.origin);
      } catch (e) {
        return Promise.reject(e);
      }
      fetchUrl.searchParams.set('section_id', sectionId);

      return fetch(fetchUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }

    function loadMore() {
      var url = nextUrl();
      if (!url || busy || sentinel.hidden) return;
      busy = true;
      sentinel.classList.add(LOADING);

      var emptyStreak = 0;

      function step(currentUrl) {
        return fetchPage(currentUrl).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = doc.querySelector('[data-bd-product-grid], #product-grid');
          var freshSentinel = doc.querySelector('[data-bd-infinite]');
          var items = freshGrid
            ? Array.prototype.slice.call(freshGrid.querySelectorAll(':scope > .collection__grid__item, :scope > li'))
            : [];

          // Fallback: any direct children if theme markup drifts
          if (!items.length && freshGrid) {
            items = Array.prototype.slice.call(freshGrid.children);
          }

          if (items.length) {
            emptyStreak = 0;
            var frag = document.createDocumentFragment();
            items.forEach(function (item) {
              frag.appendChild(document.importNode(item, true));
            });
            grid.appendChild(frag);
            stripScrollTriggers(grid);
            try {
              document.dispatchEvent(
                new CustomEvent('bd:collection-infinite:appended', {
                  detail: { grid: grid, results: results }
                })
              );
            } catch (err) {
              /* ignore */
            }
          } else {
            emptyStreak += 1;
          }

          var more = freshSentinel && freshSentinel.getAttribute('data-bd-next-url');
          if (more && !items.length && emptyStreak < MAX_EMPTY_PAGES) {
            return step(more);
          }

          setNextUrl(more || '');
        });
      }

      step(url)
        .catch(function (err) {
          if (window.console && console.warn) {
            console.warn('[bd-collection-infinite] load failed', err);
          }
        })
        .then(function () {
          busy = false;
          sentinel.classList.remove(LOADING);
          // Observer won't re-fire if sentinel stayed in view — keep filling.
          if (nextUrl() && sentinelInView(sentinel)) {
            window.requestAnimationFrame(loadMore);
          }
        });
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadMore();
        });
      },
      { root: null, rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    observer.observe(sentinel);
    results.setAttribute('data-bd-infinite-init', 'true');

    if (nextUrl() && sentinelInView(sentinel)) {
      window.requestAnimationFrame(loadMore);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(
      '[data-bd-results]:not([data-bd-infinite-init="true"])'
    );
    Array.prototype.forEach.call(roots, initResults);
  }

  function resetAndInit(scope) {
    var roots = (scope || document).querySelectorAll('[data-bd-results]');
    Array.prototype.forEach.call(roots, function (el) {
      el.removeAttribute('data-bd-infinite-init');
    });
    initAll(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    resetAndInit(e.target);
  });

  document.addEventListener('bd:collection-filter:swapped', function (e) {
    var results = e && e.detail && e.detail.results;
    if (results) {
      results.removeAttribute('data-bd-infinite-init');
      initResults(results);
    } else {
      resetAndInit(document);
    }
  });
})();
// [BD feat] Collection infinite scroll
